<template>
    <div class="copyright-index">
        <xi-top></xi-top>
        <div class="banner-out-wrapper">
            <img :src="`${IMG_HOST}anchor_banner_bg.png`">
            <div class="banner-inner-wrapper">
                <div class="content">
                    <span class="large-slogan">海量优质内容等你来播讲</span>
                    <span class="sub-slogan">让你的好声音持续被发现</span>
                    <div class="buttons">
                        <a v-if="!isAnchor" :href="`${$store.state.ANCHOR_AUTH_URL}`" target="_blank">主播认证</a>
                        <a v-else :href="`${$store.state.A_PC_HOST}/requirementview`">去参加海选</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="gain-out-wrapper">
            <div class="gain-inner-wrapper">
                <span class="title">丰富的收益模式</span>
                <div class="gain-pattern">
                    <div class="pattern">
                        <img :src="`${IMG_HOST}commission_logo.png`">
                        <span class="content">录制佣金</span>
                    </div>
                    <div class="pattern">
                        <img :src="`${IMG_HOST}gain_share_logo.png`">
                        <span class="content">收益分成</span>
                    </div>
                    <div class="pattern">
                        <img :src="`${IMG_HOST}fans_sponsor_logo.png`">
                        <span class="content">粉丝赞助</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="channels-out-wrapper">
            <div class="channels-inner-wrapper">
                <span class="title">找作品读</span>
                <div class="content-wrapper">
                    <div class="row">
                        <img :src="`${IMG_HOST}addition_logo.png`">
                        <div class="content">
                            <span class="title">参加海选</span>
                            <span class="desc">参加播讲任务选拔，按照任务要求录制一段声音样本并提交。任务发布者会在参选声音样本中，挑选优秀的主播来完成有声书录制。</span>
                        </div>
                    </div>
                    <div class="row">
                        <img :src="`${IMG_HOST}tags_logo.png`">
                        <div class="content">
                            <span class="title">丰富资料</span>
                            <span class="desc">编辑您喜欢或擅长播讲的类型作为声音标签并上传声音样本。这样能让您的好声音容易被发现，同时获得更多推荐播讲的机会。</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="best-anchor-out-wrapper">
            <div class="best-anchor-inner-wrapper">
                <span class="title">优秀主播</span>
                <div class="anchors">
                    <!--<div class="anchor">-->
                        <!--<img :src="getUploadImg(authors[0].logoPic)">-->
                        <!--<div class="content">-->
                            <!--<a :href="http://weibo.com/guichuideng?refer_flag=1005055014_" class="title" target="_blank">{{ authors[0].name }}</a>-->
                            <!--<el-tooltip :content="authors[0].intro" placement="top" popper-class="desc-popper">-->
                                <!--<p class="big-desc">-->
                                    <!--{{ authors[0].intro }}-->
                                <!--</p>-->
                            <!--</el-tooltip>-->
                        <!--</div>-->
                    <!--</div>-->

                    <div class="anchor">
                        <img :src="`${IMG_HOST}top_anchor_1.jpg`">
                        <div class="content">
                            <span class="title">有声的紫襟</span>
                            <span class="sub-title">签约主播</span>
                            <el-tooltip content="2014年6月签约平台，截止目前共录制63张专辑，累计粉丝320万" placement="top" popper-class="desc-popper">
                                <p class="big-desc">
                                    2014年6月签约平台，截止目前共录制63张专辑，累计粉丝320万
                                </p>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="anchor">
                        <img :src="`${IMG_HOST}top_anchor_2.jpg`">
                        <div class="content">
                            <span class="title">剧舞吧小宇宙</span>
                            <span class="sub-title">签约主播</span>
                            <el-tooltip content="2015年12月开始录制第一张专辑，截止目前共录制15张专辑，累计粉丝14万" placement="top" popper-class="desc-popper">
                                <p class="big-desc">
                                    2015年12月开始录制第一张专辑，截止目前共录制15张专辑，累计粉丝14万
                                </p>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="anchor">
                        <img :src="`${IMG_HOST}top_anchor_4.jpg`">
                        <div class="content">
                            <span class="title">丸子</span>
                            <span class="sub-title">签约主播</span>
                            <el-tooltip content="2015年6月开始录制有声书，截止目前共录制10张专辑，累计粉丝100万" placement="top" popper-class="desc-popper">
                                <p class="big-desc">
                                    2015年6月开始录制有声书，截止目前共录制10张专辑，累计粉丝100万
                                </p>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="help-center-out-wrapper">
            <router-link :to="{name: 'anchorAboutPlatform'}">如您还有更多疑问请查看帮助中心</router-link>
            <i class="icon icon-right-arrow-white icon-16" style="position: relative;top: 3px;"></i>
        </div>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
    import axios from 'axios';
    import XiFooter from '../components/Footer.vue';
    import XiTop from '../components/Top.vue';
    import shave from 'shave';
    export default {
        components: {
          axios,
          XiFooter,
          XiTop
        },
        data() {
            return {

            }
        },
        methods: {
            shave() {
              shave('.big-desc', 120);
            }
        },
        computed: {
          IMG_HOST(){
            return this.$store.state.IMG_HOST;
          },
          isAnchor() {
            return this.$store.state.user.anchor.level > -1
          }
        },
        mounted() {
          this.shave();
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../sass/anchor/index.scss";
    @import "../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// AnchorIndex.vue?6f9c6342